import { mapGetters, mapActions } from 'vuex';
import pushNotificationMixin from './pushNotificationMixin';
export default {
    data() {
        return {

        }
    },
    mixins: [pushNotificationMixin],
    mounted() {
        this.promptNotifications();
    },
    computed: {
        canGeolocate() {
            return !!navigator.geolocation
        },
        ...mapGetters([
            'getPromptedInstall',
            'getPromptedPushNotifications',
            'getPromptedBankDetails',
            'getAccount',
            'getAccountDetails',
        ]),
    },

    watch: {
        getAccount: {
            //Handler just watches for deep mutations
            handler() {
                this.promptBankDetails();
            },
            immediate: true,
            deep: true
        },
        installPrompt: {
            //Handler just watches for deep mutations
            handler(e) {
                console.log("HANDLED: ", e)
                this.promptInstall();
            },
            immediate: true,
            deep: true
        },
    },
    methods: {
        ...mapActions([

        ]),
        promptInstall() {
            if (this.getPromptedInstall)
                return;
            //Check that installPrompt e is caught and saved
            if (this.installPrompt === null)
                return;

            this.$emit('openInstallDialog');
            this.$store.commit("setPromptedInstall", true);
        },
        async promptNotifications() {
            const sub = await this.findSubscription()

            if (sub !== null)
                return;
            if (this.getPromptedPushNotifications)
                return;

            this.$emit('openPushNotificationDialog');
            this.$store.commit("setPromptedPushNotifications", true);


        },
        promptBankDetails() {
            if (this.getAccount == null)
                return;
            if (this.getPromptedBankDetails)
                return;
            if (this.getAccount.payeeId != '-1')
                return;
            if (this.getAccount.type != "PARTNER")
                return;

            this.$emit('openNoPaymentDialog');
            this.$store.commit("setPromptedBankDetails", true);
        },
        // promptLocation() {
        //     console.log("LOCATION PROMPT", this.canGeolocate);
        //     if (this.getPromptedBankDetails)
        //         return;
        //     if (this.canGeolocate)
        //         return;

        //     this.$emit('openGeoDialog');
        //     this.$store.commit("setPromptedLocation", true);
        // },

    }
}